export function byCaseInsensitive({ property, order = 'asc' }) {
  return (a, b) => {
    const result = a[property].localeCompare(b[property], undefined, {
      sensitivity: 'base',
    });
    return order === 'desc' ? -result : result;
  };
}

export const alphabeticalSort = (firstItem, secondItem) => {
  if (!firstItem) {
    return -1;
  }
  if (!secondItem) {
    return +1;
  }
  return firstItem.localeCompare(secondItem);
};
